import Vue from '@/setup'

import { RouteHelper } from '@/helpers/Route'
import { StatusHelper } from '@/helpers/Status'
import store from '@/store'
import { ROUTE_INDEX_SUBMIT } from '@/config/constants'
import { BasketHelper } from '@/helpers/Basket'

export default [
  {
    beforeEnter: (_to, from, next) => {
      const basket = RouteHelper.getBasket()

      if (!StatusHelper.offerValid(basket, basket.persons)) {
        if (from.name) {
          store.dispatch('turnOnValidation')
          next({
            name: from.name,
            params: from.params,
          })
        } else {
          next({
            name: RouteHelper.getNextRoute(basket),
            replace: true,
          })
        }
      } else {
        Vue.prototype.$loading.start()

        // backend needs to know every time the submit screen is entered
        BasketHelper.updateBasket({})
          .then(basket => {
            return BasketHelper.newUpdateBasket(basket, { submitScreen: true })
          })
          .then(() => {
            Vue.prototype.$loading.end()
            next()
          })
      }
    },
    component: () => import(/* webpackChunkName: "screen-submit" */ '@/modules/Configurator/screens/Submit.vue'),
    meta: {
      index: ROUTE_INDEX_SUBMIT,
      basket: {
        readonly: true,
      },
    },
    name: 'submit',
    path: '/submit',
  },
]
